import { Injectable, Injector, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackBarService } from '../service/snack-bar.service';

@Injectable()
export class ApiErrorsInterceptor implements HttpInterceptor {
  private injector = inject(Injector);

  snackBarService: SnackBarService;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.snackBarService = this.injector.get(SnackBarService);
        const status = error?.status;
        const message =
          typeof error?.error?.message?.message === 'string'
            ? error?.error?.message.message
            : typeof error?.error?.message === 'string'
              ? error?.error?.message
              : error?.error?.message?.message[0];

        switch (status) {
          case 403:
            this.snackBarService.openSnackBar(message || 'Not authorized');
            break;
          case 404:
            this.snackBarService.openSnackBar(message || '404 Not found');
            break;
          case 400:
            this.snackBarService.openSnackBar(message || '400 Bad request');
            break;
          default:
            this.snackBarService.openSnackBar(message || `${status || ''} Service problem`);
        }
        return throwError(error);
      }),
    );
  }
}
